import React, { useContext, useState, useEffect } from 'react';
import './report-summary.scss';
import RightModal from '../../atoms/right-modal/right-modal';
import ReportSchedule from '../report-schedule/report-schedule';
import { ReactComponent as CalendarIcon } from '../../../assets/svg/calendar.svg';
import { ReportsService } from '../../../services';
import { ToasterContext, UserContext } from '../../../context';
import { useHistory } from 'react-router-dom';
import { ModalWindow, AppTooltip, ActionLink, CommonToaster } from '../../atoms';
import { default as t } from '../../../utils/i18n';
import { Button } from 'rsuite';

const ReportSummary = ({ activeStep, setActiveStep, stepperData, draftReportId }) => {
  const [openSliderModal, setOpenSliderModal] = useState(false);
  const [metrics, setMetrics] = useState([]);
  const history = useHistory();

  const [reportResponse, setReportResponse] = useState([]);
  const { user, setUser } = useContext(UserContext);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);

  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const reportId = draftReportId ? draftReportId : stepperData?.data?.data?.reportId;
  const typeMapping = {
    LIVE: t('define.summary.live'),
    EOCR: t('define.summary.eocr'),
    PCA: t('define.summary.pca'),
  };
  const frequencyMapping = {
    7: t('define.summary.weekly'),
    15: t('define.summary.fortnightly'),
    30: t('define.summary.monthly'),
  };
  const scheduleMapping = {
    0: t('define.summary.sunday'),
    1: t('define.summary.monday'),
    2: t('define.summary.tuesday'),
    3: t('define.summary.wednesday'),
    4: t('define.summary.thursday'),
    5: t('define.summary.friday'),
    6: t('define.summary.saturday'),
  };
  const monthlyMapping = {
    1: t('define.summary.each'),
    2: t('define.summary.2nd'),
    3: t('define.summary.3rd'),
  };
  const handleOpenSliderModal = () => {
    setOpenSliderModal(!openSliderModal);
  };

  const handleClick = value => {
    setActiveStep(activeStep - 1);
  };
  const onSubmit = async () => {
    try {
      const payload = {
        status: 'SUBMITTED',
        "reportName": user?.reportName
      };
      const reportResponse = await ReportsService.updateReportDetails(
        userAccessToken,
        username,
        payload,
        reportId,
        user?.isSaveDraft
      );
      const reportData = reportResponse?.data?.data;
      setUser(prevUser => ({
        ...user,
        isSaveDraft: false,
        isSubmitted: true
      }));
      setTheMessages({message: t('report.summary.created.success'), isError: false})
      history.push('/reports');
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '-' + mm + '-' + yyyy;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getReportResponse();
    if (draftReportId) {
      let msg = t('mgs.success.saveStep');
      setTheMessages({ message: msg, isError: false });
    }
  }, []);

  async function getReportResponse() {
    try {
      const reportRes = await ReportsService.getReportDetails(
        userAccessToken,
        username,
        reportId
      );
      let resultedReportResponse = reportRes?.data?.data;
      setReportResponse(resultedReportResponse);
      generateMetrics(resultedReportResponse);
      setUser(prevUser => ({
        ...user,
        selectedAdvertiser: resultedReportResponse?.advertiser,
        selectedAdaccounts: resultedReportResponse?.campaigns[0]?.accountId
      }));
      //  generateAttribute(resultedReportResponse);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }
  function getAttributeName(idArray) {
    const name = [];
    idArray?.length > 0 &&
      idArray?.forEach(id => {
        user?.attributes?.forEach(idx => {
          if(id === idx.sys_id){
            name.push(idx.name);
          }
        })
      });
    return name;
  }

  function generateMetrics(response) {
    const name = [];
    response?.metrics.length > 0 &&
      response?.metrics.forEach(idx => {
        user?.kpiList?.length > 0 &&
          user?.kpiList?.forEach(id => {
            if (idx.sys_id === id.sys_id) {
              name.push(id.KPI_Metric);
            }
          });
      });
    setMetrics([...name]);
  }

  const handleCancelClick = (e) => {
    e.preventDefault();
    setShowCancelModal(true);
    setIsBackClicked(false)
  }

  const handleOnCloseCancelModal = () => {
    setShowCancelModal(false);
    setIsBackClicked(false)
  }

  const onContinue = (e) => {
    e.preventDefault();
    setShowCancelModal(false);
    setUser(prevUser => ({
      ...user,
      isSaveDraft: false,
    }));
    if (isBackClicked) {
      setActiveStep(activeStep - 1);
    } else {
      if(user?.isFirstTimeCreation) {
        handleDeleteReport({reportId: reportId})
      } else {
        history.push('/reports');
      }
    }
  }

  async function handleDeleteReport(payload) {
    try {
      const deleteRes = await ReportsService.deleteReport(
        userAccessToken,
        username,
        payload
      );
      const delResponse = deleteRes.data?.data;
      if(delResponse.message === "Successfully Updated"){
        setUser(prevUser => ({
          ...user,
          isFirstTimeCreation: false,
        }));
      }
      history.push('/reports');
    } catch (error) {
      setUser(prevUser => ({
        ...user,
        isFirstTimeCreation: false,
      }));
      history.push('/reports');
    }
  }

  const onSaveDraft = (e) => {
    e.preventDefault();
    handleClick('', true);
    if (isBackClicked) {
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      setActiveStep(activeStep - 1);
    } else {
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      history.push('/reports');
    }
    setShowCancelModal(false);
  }

  const onCancelReq = () => {
    setIsBackClicked(false)
    setShowCancelModal(false);
  }

  const handleBackClick = () => {
    setIsBackClicked(true);
    setShowCancelModal(true);
  };

  const setTheMessages = (message) => {
    if (message?.message) {
      setToaster(true);
      setMessage([]);
      setMessage(message);
      clearToaster();
    } else {
      setToaster(false);
      setMessage([]);
    }
  }


  let clearToaster = () => {
    setTimeout(() => {
      setToaster(false);
    }, 7000);
  };

  return (
    <div className="report-summary">
      <div className={toaster ? 'toasterTop' : ''}>
        <CommonToaster message={message} toaster={toaster}></CommonToaster>
      </div>
      <div className='exit'>
        <button className="step-cancel" onClick={handleCancelClick}>
          {t('report.client.reporting.exit')}
        </button>
      </div>
      {reportResponse?.type === 'LIVE' ? (
        <div className="summary-header">
          <h3>{t('define.summary.header')}</h3>
          <div className="schedule-header">
            {reportResponse?.frequency ? (
              <div className="frequency">
              
              <CalendarIcon />{' '}
                {frequencyMapping[reportResponse?.frequency] +
                  ' | ' +
                  (reportResponse?.frequency === 30
                    ? `${t('define.summary.every')} ${reportResponse?.deliverySchedule?.dateOfMonth} ${t('define.summary.of')} ${monthlyMapping[reportResponse?.deliverySchedule?.monthlyRecurrence]
                    } ${t('define.summary.month')}`
                    : scheduleMapping[reportResponse?.deliverySchedule?.dayOfWeek])}
              </div>
            ) : (
              ''
            )}
            <div
              onClick={() => setOpenSliderModal(!openSliderModal)}
              className="right-btn-container"
            >
              
           
               <CalendarIcon data-for="tool-tip2"
              data-tip={t('define.summary.calender.tooltip')}/>
               <AppTooltip
                    className="c-table-info-icon--tooltip"
                    id="tool-tip2"
                    place="bottom"
                  />
         
              <h6>
                {' '}
                {reportResponse?.frequency ? t('define.summary.btn.name1') : t('define.summary.btn.name2')} <span className='imp-icon'>*</span>
              </h6>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}

      <div className="report-type-container">
        <div>
          <h5>{t('define.summary.reportType')}</h5>
          <p>{typeMapping[reportResponse?.type]}</p>
        </div>
        <div>
          <h5>{t('reportTable.text.advertiser')}</h5>
          <p>{reportResponse?.advertiser}</p>
        </div>
        <div>
          <h5>{t('define.summary.reportPeriod')}</h5>
          <p>
            {updateDateFormat(reportResponse?.startDate)} -{' '}
            {updateDateFormat(reportResponse?.endDate)}
          </p>
        </div>
      </div>
      <div className="campaigns-details-container">
        <div className="content">
          <h5>{t('define.stepper.adAccount')}</h5>
          <h5>{t('define.summary.campaigns')}</h5>
          <h5>{t('define.stepper.table.objective')}</h5>
        </div>
        {reportResponse?.campaigns?.map((attr, index) => (
          <>
            <div key={index} className="content">
              <p title={attr.accountName}>{attr.accountName}</p>

              <p title={attr.campaignName}>{attr.campaignName}</p>

              <p title={attr.objective}>{attr.objective}</p>
            </div>
          </>
        ))}
      </div>
      <div className="metrics-container">
        <h5>{t('define.summary.metrics')}</h5>
        <p title={metrics?.join(', ')}>{metrics?.join(', ')}</p>
      </div>
      <div className="breakdown-container">
        <div className="content">
          <h5>{t('define.summary.breakdown')}</h5>
          <h5>{t('define.summary.attributes')}</h5>
        </div>
        {reportResponse?.reportBreakdown?.sort((a, b) => a?.order - b?.order).map((attr, index) => (
          <>
            <div key={attr.tableTitle + index} className="content">
              <p title={attr.tableTitle}>{attr.tableTitle}</p>
              <p title={getAttributeName(attr?.attributes).join(', ')}>
                {getAttributeName(attr?.attributes).join(', ')}
              </p>
            </div>
          </>
        ))}
      </div>
      <div className="btn-steps">
        <button
          className="step-back"
          disabled={activeStep === 0}
          label="Back"
          onClick={handleBackClick}
        >
          {t('define.report.stepper.button.back')}
        </button>

        <span className="step-next"
          data-tip={reportResponse?.type === 'LIVE' && !reportResponse.frequency ? t('define.summary.next.btn.tooltip') : ''}
          data-for="tool-tip3">
          <button
            className="step-next"
            onClick={onSubmit}
            label="Confirm and submit"
            disabled={reportResponse?.type === 'LIVE' && !reportResponse.frequency}
          >  {t('define.summary.confirm.submit')}</button>

        </span>
        <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip3" place="left" />

      </div>

      <RightModal openSliderModal={openSliderModal}>
        <ReportSchedule
          handleOpenSliderModal={handleOpenSliderModal}
          reportId={reportId}
          getReportResponse={getReportResponse}
          frequencyMapping={{
            frequency: reportResponse?.frequency,
            deliverySchedule: reportResponse?.deliverySchedule,
          }}
        />
      </RightModal>

      <div className="report-delete">
        <ModalWindow
          className="fqa-modal--showanswer"
          isOpen={showCancelModal}
          onRequestClose={handleOnCloseCancelModal}
          heading={!isBackClicked ? t('define.stepper.cancel.heading') : t('define.stepper.back.heading')}
          ariaHideApp={false}
        >
          <p className="fqa-model-showanswer--message message-font">
            {!isBackClicked ? t('define.stepper.cancel.request') : t('define.stepper.back.subHeading')}
          </p>
          <p>
          </p>
          <div className="fqa-model-pa--actions">
            <ActionLink
              anchor={true}
              value={!isBackClicked ? t('define.stepper.save') : t('define.stepper.back.save')}
              handleClick={onSaveDraft}
            />
            <ActionLink
              anchor={true}
              value={!isBackClicked ? t('define.stepper.cancel.continue') : t('define.stepper.back.continue')}
              handleClick={onContinue}
            />
            <Button
              className="fqa-model-pa--actions-confirm delete-button"
              onClick={onCancelReq}
            >{t('define.stepper.cancel')}</Button>
          </div>
        </ModalWindow>
      </div>
    </div>
  );
};

export default ReportSummary;
